// Modal.js
import React from 'react';

const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null; // Don't render anything if modal is not open

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg md:max-w-[50%] max-w-[80%] w-full p-6 animate-appear">
                <h2 className="text-xl font-semibold">{title}</h2>
                <button className="absolute top-4 right-4 text-gray-600 hover:text-gray-900" onClick={onClose}>
                    &times;
                </button>
                <div className="mt-4">{children}</div>
                <div className="mt-6 text-right">
                    <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
